export const BEARER = "Bearer ";
export const TOKEN_NAME = 'sl-token';
export const LOGGED_IN_USER = 'sl-admin-user';

export const ROLES = {
  SUPER_ADMIN: {
    id: 1,
    name: 'SuperAdmin',
  },
  ADMIN: {
    id: 2,
    name: 'Admin',
  },
  USER: {
    id: 3,
    name: 'User',
  },
}

export const QUERY_KEYS = {
  USERS: 'users',
  ROLES: 'roles',
  LOGS: 'logs',
  LINKS: 'links',
  ANALYTICS: 'analytics',
  WHITELIST_IPS: 'whitelist-ips'
};